// @ts-nocheck
import { DocumentNode } from "graphql";
import { CompanyFilter } from "../types/companyFilter";
import { useQuery } from "@apollo/client";
import { sanitizeCompanyFilters } from "../utils/companyFilterUtils";
import { COMPANY_SEARCH_CLIENT } from "../../utils/consts";

export const useCompanySearchQuery = <
  Response,
  T_Vars = Record<string, unknown>,
>(options: {
  opportunityGeneratorFilters: CompanyFilter;
  productCategoryIds?: string[];
  vendorsIds?: number[];
  variables?: T_Vars;
  localizeInstalls: boolean;
  query: DocumentNode;
  skip?: boolean;
  cache?: boolean;
}) => {
  return useQuery<Response>(options.query, {
    variables: {
      opportunityGeneratorFilters: sanitizeCompanyFilters(
        options.opportunityGeneratorFilters,
        true
      ),
      productCategoryIds:
        options.productCategoryIds ||
        options.opportunityGeneratorFilters.productCategories?.ids ||
        [],
      vendorsIds: options.vendorsIds,
      localizeInstalls: options.localizeInstalls,
      ...options.variables,
    },
    skip: options.skip,
    context: { clientName: COMPANY_SEARCH_CLIENT },
    fetchPolicy: options.cache === false ? "no-cache" : undefined,
  });
};
